import FORMAT from 'config/date/format';
import moment from 'moment';

const eventMoment = e => moment(e.start_date, FORMAT);

const archive = datestring => moment(datestring, FORMAT).diff(moment(), 'hours') <= 0;

export default events => events?.filter(e => archive(e.start_date))?.sort((a, b) => eventMoment(b).diff(eventMoment(a))) || [];